import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { usePaymentStatuses } from '../../../utilities/hooks/usePaymentStatuses';

const MultipeCustomPaymentCheckbox = ({
	label,
    checbboxObj,
    itemKey,
	onFilterPaymentStatusSelected,
	setEnableScheduling,
	filterCount,
	name = null,
	type
}) => {
	const getSize = () => {
		if (!type) {
			return '16px';
		} else {
			if (type === 1) {
				return '16px';
			} else if (type === 2) {
				return '24px';
			}
		}
	};

    const paymentStatuses = usePaymentStatuses();
    const [checkboxChecked, SetCheckboxChecked] = useState(false);
   
    useEffect(() => {
		SetCheckboxChecked(checbboxObj[itemKey]);
	}, []);

    const setCheckboxCheckedChoose = (itemKey) => {
		let statusIds = JSON.parse(localStorage.getItem('bookings_filter_payment_status')) || [];
        SetCheckboxChecked(!checbboxObj[itemKey]);
        checbboxObj[itemKey] = !checbboxObj[itemKey];
        Object.keys(paymentStatuses).map((paymentStatus) => {
            if (paymentStatus === itemKey) {
				if (checbboxObj[paymentStatus] === true) {
					if (!statusIds.includes(paymentStatus)) {
						statusIds.push(paymentStatus);
					}
				} else {
					if (statusIds.includes(paymentStatus)) { 
						for( var i = 0; i < statusIds.length; i++) { 
							if ( statusIds[i] === paymentStatus) { 
								statusIds.splice(i, 1); 
							}
						
						}
					}
				}

            }
        });

		if (statusIds.length > 0) {
			localStorage.setItem('bookings_filter_payment_status', JSON.stringify(statusIds));
			setEnableScheduling(true);
		} else {
			localStorage.removeItem('bookings_filter_payment_status');
			if (filterCount - 1 <= 0) {
				setEnableScheduling(false);
			}
		}
		
		onFilterPaymentStatusSelected(statusIds);
    }

	return (
		<div
			onClick={() => setCheckboxCheckedChoose(itemKey)}
			className="form-check-container"
			style={{ marginLeft: '0' }}
			data-testid={name ? name : 'custom-checkbox'}
		>
			<div
				style={{ width: getSize(), height: getSize() }}
				className={
					'custom-checkbox ' +
					(checkboxChecked
						? type === 1 || !type
							? 'custom-checkbox-checked'
							: 'custom-checkbox-checked-medium'
						: 'custom-checkbox')
				}
			/>
			<label
				style={{ marginBottom: 0, marginLeft: '10px', fontWeight: 400 }}
				className="checkbox-label"
			>
				{label}
			</label>
			{name ? (
				<input
					name={name}
					type="checkbox"
					style={{ display: 'none' }}
					checked={checkboxChecked}
					readOnly={true}
					data-testid={name}
				/>
			) : null}
		</div>
	);
};

MultipeCustomPaymentCheckbox.propTypes = {
	label: PropTypes.string,
	name: PropTypes.string,
	onChange: PropTypes.func,
	type: PropTypes.number,
	itemKey: PropTypes.string,
    checbboxObj: PropTypes.array,
	onFilterPaymentStatusSelected: PropTypes.func,
	setEnableScheduling: PropTypes.func,    
	filterCount: PropTypes.number
};

export default MultipeCustomPaymentCheckbox;
